<div class="app-doc-editor-drawer-content flex flex-column justify-between pt1 pb2">
  <div>
    <div *ngFor="let signer of signers" class="mb1">
      <div
        class="app-signer pl3 pr1 py1"
        [class.app-signer--active]="signer.personalId === activeSigner.personalId"
        (click)="clickSigner.emit(signer)"
      >
        <div class="app-signer-first-row flex items-center justify-between">
          <div class="app-signer-name mr2 pr2">
            <span>{{ signer | personFullName }}</span>
          </div>

          <lib-button
            [onlyIcon]="signFieldsExpansionMap[signer.personalId] ? 'expand_less' : 'expand_more'"
            weight="tertiary"
            [small]="true"
            (click)="toggleSignFieldList(signer)"
          ></lib-button>
        </div>

        <div class="font-small flex items-center">
          <lib-icon icon="history_edu" [inline]="true" class="font-medium mr1"></lib-icon>
          {{ 'DOC_EDITOR.SET_SIGN_FIELDS' | translate }}
          {{ (signFields | filterSignFieldsBySigner : signer).length }}
        </div>
      </div>

      <mat-expansion-panel
        hideToggle
        class="app-signer-sign-fields mat-elevation-z0"
        [expanded]="signFieldsExpansionMap[signer.personalId]"
      >
        <app-sign-field-list-item
          *ngFor="let signField of signFields | filterSignFieldsBySigner : signer; let i = index"
          [signField]="signField"
          [name]="'SIGN_FIELD_LIST_ITEM.NAME' | translate : { index: i + 1 }"
          [active]="signField.id === activeSignField?.id"
          [showSignFieldPriority]="showSignFieldPriority"
          (click)="clickSignField.emit(signField)"
          (deleteSignField)="deleteSignField.emit(signField)"
          (changeSignFieldType)="changeSignFieldType.emit($event)"
          (changeSignFieldPriority)="changeSignFieldPriority.emit($event)"
        ></app-sign-field-list-item>
      </mat-expansion-panel>
    </div>
  </div>
</div>
